export const ADD_USER = 'ADD_USER';
export const UPDATE_BOT_SETTING_HOTEL = 'UPDATE_BOT_SETTING_HOTEL';

export const ALL_STATISTICS = 'ALL_STATISTICS';
